export default "__VITE_ASSET__DCnIj6qK__"